import React, { Fragment } from 'react'

import PageSection from './PageSection'
import Button from './Button'
import LanguageTag from './LanguageTag'

import { trackThenLeaveToDevConsole } from '../../utils/tracking'

import CONSOLE_URL from '../../config'

const availableLanguages = ['English', 'French', 'German', 'Japanese']
const comingSoonLanguages = [
  'Chinese',
  'Spanish',
  'Arabic',
  'Russian',
  'Italian',
  'Korean',
  'Portuguese',
  'Turkish'
]

export default function CustomVoiceInterfaces () {
  return (
    <PageSection
      extraClass='enterprise-page__custom-voice-interfaces bg-primary center'
      beforeSection={
        <Fragment>
          <h2 className='h2 mb3'>Custom Voice Interfaces</h2>
          <p className='col-11 text-para maxw-text mb3 mx-auto'>
            Our Console makes building production-ready prototypes easy. Sign up
            today to join thousands of developers and businesses already
            building with Snips.
          </p>
          <Button
            className='button button--large button--primary mb4'
            href={CONSOLE_URL}
            onClick={e => trackThenLeaveToDevConsole(e, 'Enterprise Page')}
            forceAnchorElement
          >
            Start Building for Free
          </Button>
          <div className='col-11 sm-col-10 mb3 mx-auto'>
            <img
              className='enterprise-page__custom-voice-interfaces__screenshot '
              src='/static/images/enterprise/intent-editor-1200.png'
              alt='console.snips.ai - intent editor screenshot'
            />
          </div>
          <ul className='enterprise-page__custom-voice-interfaces__languages col-11 maxw-medium flex flex-wrap white mx-auto'>
            {availableLanguages.map((lang, idx) => (
              <LanguageTag
                key={idx}
                lang={lang}
                extraClass='button--outline'
                icon='checked'
              />
            ))}
          </ul>
        </Fragment>
      }
    >
      <div className='enterprise-page__custom-voice-interfaces__coming-soon white col-11 maxw-medium mx-auto center py3 relative'>
        <img
          src='/static/images/icons/world.svg'
          alt='world icon'
          className='enterprise-page__custom-voice-interfaces__world-icon mb3'
        />
        <h4 className='h3 mb3'>Coming soon</h4>
        <p className='text-para white maxw-small mx-auto mb3'>
          Snips is building a global voice platform to cater to your customers -
          no matter what language they speak
        </p>
        <ul className='sm-col-10 flex justify-center flex-wrap mx-auto'>
          {comingSoonLanguages.map((lang, idx) => (
            <LanguageTag key={idx} lang={lang} extraClass='bg-primary-alt' />
          ))}
        </ul>
      </div>
    </PageSection>
  )
}



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/CustomVoiceInterfaces.js